// project import
import dashboard from './dashboard';
import users from './users';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, users]
};

export default menuItems;
